import { CompanyDto } from './company-dto.model';


export class RoleDto implements IRoleDto {
    id!: number;
    company!: CompanyDto;
    roleName!: string | undefined;
    isActive!: boolean;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.roleName = _data["roleName"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["roleName"] = this.roleName;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IRoleDto {
    id: number;
    company: CompanyDto;
    roleName: string | undefined;
    isActive: boolean;
}

